import React from "react";
import { Route, Switch } from "react-router-dom";
import App from "./containers/App";
import DashboardPage from "./containers/DashboardPage";
import ClientDashboardPage from "./containers/ClientDashboard/ClientDashboardPage";
import EditEmailPage from "./containers/EditEmail/EditEmailPage";
import EditEmailModulePage from "./containers/EditEmailModule/EditEmailModulePage";
import EditEmailTemplatePage from "./containers/EditEmailTemplate/EditEmailTemplatePage";
import ListEmailPage from "./containers/ListEmail/ListEmailPage";
import ListEmailModulePage from "./containers/ListEmailModule/ListEmailModulePage";
import ListEmailTemplatePage from "./containers/ListEmailTemplate/ListEmailTemplatePage";
import ListImagePage from "./containers/ListImage/ListImagePage";
import ListCampaignPage from "./containers/ListCampaign/ListCampaignPage";
import ViewCampaignPage from "./containers/ViewCampaign/ViewCampaignPage";
import QAEmailPage from "./containers/QAEmail/QAEmailPage";

export default (
  <App>
    <Switch>
      <Route exact path="/" component={DashboardPage} />
      <Route exact path="/clients/:accountId" component={ClientDashboardPage} />
      <Route
        exact
        path="/clients/:accountId/emails"
        component={ListEmailPage}
      />
      <Route
        exact
        path="/clients/:accountId/emails/:id"
        component={EditEmailPage}
      />
      <Route
        exact
        path="/clients/:accountId/email-modules"
        component={ListEmailModulePage}
      />
      <Route
        exact
        path="/clients/:accountId/email-modules/:id"
        component={EditEmailModulePage}
      />
      <Route
        exact
        path="/clients/:accountId/email-templates"
        component={ListEmailTemplatePage}
      />
      <Route
        exact
        path="/clients/:accountId/email-templates/:id"
        component={EditEmailTemplatePage}
      />
      <Route
        exact
        path="/clients/:accountId/emails/:id/qa"
        component={QAEmailPage}
      />
      <Route
        exact
        path="/clients/:accountId/images"
        component={ListImagePage}
      />
      <Route
        exact
        path="/clients/:accountId/campaigns"
        component={ListCampaignPage}
      />
      <Route
        exact
        path="/clients/:accountId/campaigns/:id"
        component={ViewCampaignPage}
      />
      <Route
        exact
        path="/clients/:accountId/campaigns/:campaignId/emails/:id"
        component={EditEmailPage}
      />
      <Route
        exact
        path="/clients/:accountId/campaigns/:campaignId/emails/:id/qa"
        component={QAEmailPage}
      />
    </Switch>
  </App>
);
